import React from 'react';
import { useLocation } from 'react-router-dom';
import Logo from '../../components/common/Logo';
import Sidebar from '../../components/patient/PatientSidebar';
import DoctorDetail from '../../components/patient/PatientDoctorDetails';

const DoctorDetailPage = () => {
  const location = useLocation();
  const doctor = location.state?.doctor;

  return (
    <div className="flex min-h-screen">
      <div className="w-64 bg-white shadow-md">
        <div className="p-4">
          <Logo />
        </div>
        <Sidebar />
      </div>

      <div className="flex-1 p-8 bg-[#FAF4EB]">
        {!doctor ? (
          <div>Caricamento...</div>
        ) : (
          <>
            <header className="mb-6">
              <h1 className="text-2xl font-bold">Dettaglio del professionista</h1>
            </header>
            <DoctorDetail doctor={doctor} />
          </>
        )}
      </div>
    </div>
  );
};

export default DoctorDetailPage;